import CardComponent from '@/components/CardComponent'
import Section from '@/components/Section'

import styles from './index.module.scss'

const AutoPayStatus = ({ data }) => {
  const component = data?.components?.items?.[0]

  if (!component) {
    return null
  }

  return (
    <Section title={data?.title}>
      <CardComponent>
        <div className='ew-d-flex ew-align-items-start ew-gap-8'>
          {/* Status Indicator */}
          <div className={`${styles.statusIndicator} ew-mt-6`} />
          <div className='ew-d-flex ew-flex-column ew-flex-grow-1'>
            <div className='ew-fw-semi-bold'>{component.title}</div>
            <div className='ew-typography-small ew-color-secondary ew-fw-regular'>
              {component.subtitle}
            </div>
          </div>
        </div>
      </CardComponent>
    </Section>
  )
}

export default AutoPayStatus
